<script lang="ts">
  import { Button, Col, Form, Input, Label, Row } from "sveltestrap";
  import { InlineForm, InlineFormwithLabel, InlineFormwithoutLabel, InlineMessag, Login, Password, Username } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import InlineFormWithLabel from "./InlineFormWithLabel.svelte";
  import InlineFormWithoutLabel from "./InlineFormWithoutLabel.svelte";
</script>
<Col xl='12'>
    <Card cardHeaderprops="pb-0" headerTitle={InlineForm}>
      <div slot="customheader">
        <span>{@html InlineMessag}</span>
      </div>
      <div slot="contentbody">
        <InlineFormWithLabel />
        <InlineFormWithoutLabel />
      </div>
    </Card>
</Col>